import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const PaymentMethodSelectStyles = () => {
  const theme = useTheme();
  return {
    content: {
      heading: {
        color: theme.palette.grey[900],
      },
      actionBtn: {
        width: "240px",
      },
    },
  };
};
